
import { setSiteMode } from '@/services/mode/siteModeService';


export default [
{
    path: '/federation/:federation/:page',
    name: 'federation',
    beforeEnter: async (to: any, from: any, next: any) => {
      const { federation, page } = to.params;

      // Call the API to set the user's site mode
      setSiteMode(federation);

      // Redirect to the desired page with mode set in query string
      let query = to.query;
      query.mode = federation;
      next({ path: `/${page}`, query: query });
    },
    component: () => import('@/layouts/DefaultLayout.vue'),
  }]